module.exports = __webpack_public_path__ + "img/ch42.718608ac.jpg";